var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7926_54232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8836 7C16.7477 7 18 8.30796 18 10.2542V14.7458C18 16.692 16.7477 18 14.883 18H10.1164C8.25229 18 7 16.692 7 14.7458V10.2542C7 8.30796 8.25229 7 10.1164 7H14.8836ZM15.4901 12.8025C14.9006 12.4347 14.4454 12.9512 14.3226 13.1164C14.2042 13.2759 14.1025 13.4519 13.9952 13.6278C13.733 14.062 13.4327 14.5626 12.9128 14.8538C12.1573 15.2721 11.5838 14.8867 11.1712 14.6063C11.0164 14.5019 10.8659 14.4031 10.716 14.3373C10.3466 14.1778 10.0142 14.3594 9.52087 14.9861C9.26204 15.3136 9.00541 15.6382 8.74547 15.9618C8.59006 16.1553 8.62711 16.4539 8.83673 16.5833C9.17133 16.7893 9.5795 16.9 10.0408 16.9H14.676C14.9376 16.9 15.1998 16.8642 15.4498 16.7825C16.0128 16.5986 16.4597 16.1775 16.693 15.6212C16.8899 15.1535 16.9856 14.5859 16.8014 14.1137C16.7401 13.957 16.6482 13.8111 16.5194 13.6829C16.1815 13.3474 15.8657 13.0341 15.4901 12.8025ZM10.5744 9.2C9.81612 9.2 9.2 9.81695 9.2 10.575C9.2 11.333 9.81612 11.95 10.5744 11.95C11.3321 11.95 11.9487 11.333 11.9487 10.575C11.9487 9.81695 11.3321 9.2 10.5744 9.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7926_54232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFilledIcon);
export default __webpack_public_path__ + "static/media/banner-filled-icon.a98e021820e4fd6ae47e7acd2c21180f.svg";
export { ForwardRef as ReactComponent };